
























import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mutations, Actions, Buttons } from '@/ts/store/Constants';
import PreviewTicket from '@/components/User/Panels/PreviewTicket.vue';
import PreviewTicketConversation from '@/components/User/Panels/PreviewTicketConversation.vue';
import AddNewTicketType from '@/components/User/Panels/AddNewTicketType.vue';
import StaffTicketsList from '@/components/User/Panels/StaffTicketsList.vue';
import TenantTicketsList from '@/components/User/Panels/TenantTicketsList.vue';
import TenantTicketsHeader from '@/components/User/Panels/TenantTicketsHeader.vue';
import StaffTicketsHeader from '@/components/User/Panels/StaffTicketsHeader.vue';
import DateMethods from '@/mixins/DateMethods.vue';
import { saveScroll } from '@/plugins/save-position';

@Component({
    components: {
        PreviewTicket,
        PreviewTicketConversation,
        AddNewTicketType,
        StaffTicketsList,
        TenantTicketsList,
        TenantTicketsHeader,
        StaffTicketsHeader,
    },
    computed: {
        ...mapGetters({
            allUserTickets: 'UserTickets/getAllUserTickets',
            previewTicketVisibility: 'UserTickets/getPreviewTicketVisibility',
            addNewTicketTypeVisibility: 'UserTickets/getAddNewTicketTypeVisibility',
            previewTicketComversationVisibility: 'UserTickets/getPreviewTicketComversationVisibility',
            globalOverlayWasOpenedLocally: 'Viewport/getGlobalOverlayWasOpenedLocally',
        }),
    },
})
export default class UserTickets extends Mixins(DateMethods) {
    public staffTicketsId: string = 'hoc-adminapp-tickets';

    constructor() {
        super();
    }

    get isStaff() {
        return this.$store.getters['User/getUser']
            ? !this.$store.getters['User/getUser'].isTenant
            : false;
    }

    public beforeCreate() {
        this.$store.commit(Mutations.SET_TICKET_SEARCH_QUERY, '');
    }

    public created() {
        const headerText  = this.isStaff ? 'Tickets' : 'My Tickets';
        const leftButton  = Buttons.None;
        const rightButton = this.isStaff ? Buttons.UserProfileButton : Buttons.None;

        this.$store.commit(Mutations.SET_HEADER_TEXT, headerText);
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, leftButton);
        this.$store.commit(Mutations.SET_RIGHT_HEADER_BUTTON, rightButton);
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, true);
    }

    public mounted() {
        this.$store.dispatch(Actions.FETCH_ALL_USER_TICKETS, { vue: this, type: this.isStaff ? 'my' : 'all' });
    }

    public beforeRouteLeave(to, from, next) {
        if (this.isStaff) {
            saveScroll(this.staffTicketsId, Mutations.SET_STAFF_APP_PAGE_SCROLL_POSITION);
        }
        next();
    }

    public destroyed() {
        this.$store.commit(Mutations.SET_PREVIEW_TICKET_VISIBILITY, false);
        this.$store.commit(Mutations.SET_PREVIEW_TICKET_CONVERSATION_VISIBILITY, false);
        this.$store.commit(Mutations.SET_ADD_NEW_TICKET_ANSWER_VISIBILITY, false);
        this.$store.commit(Mutations.SET_ADD_NEW_TICKET_THANKS_VISIBILITY, false);
    }
}
